import { isNud } from '@/shared/utilities/typing'
import Theme from '@/shared/models/entities/kumiiro/theme'

/**
 * クミイロ図案カテゴリ
 */
class Category {
    category_id;
    category_name;
    priority;
    themes;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.category_id = properties.category_id;
        this.category_name = properties.category_name;
        this.priority = properties.priority;
        this.themes = [];
        if ('themes' in properties) {
            for (let theme of properties.themes) {
                this.themes.push(new Theme(theme));
            }
        }
    }
}

export default Category;
